import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InjectionToken, LOCALE_ID, Provider } from '@angular/core';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter } from '@angular/material-moment-adapter';
import { INTERCEPTORS } from './app.interceptors';
import { environment } from 'src/environments/environment';

registerLocaleData(es);

export const IS_PRODUCTION = new InjectionToken<boolean>('IS_PRODUCTION', {
  providedIn: 'root',
  factory: () => false
});


export const APP_PROVIDERS: Provider[] = [
  { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
  { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  { provide: DateAdapter, useClass: MomentDateAdapter },
  INTERCEPTORS,
  { provide: LOCALE_ID, useValue: 'es-*' },
  { provide: MatDialogRef, useValue: {} },
  { provide: MAT_DIALOG_DATA, useValue: [] },
  { provide: IS_PRODUCTION, useValue: environment.production }
];
